import React from 'react';
import { Button } from '../ui/button';
import {
  Monitor, Tablet, Smartphone, Undo2, Redo2, Save, Eye, Rocket, X, RotateCcw,
} from 'lucide-react';

const DEVICES = [
  { key: 'desktop', icon: Monitor, label: 'Desktop' },
  { key: 'tablet', icon: Tablet, label: 'Tablet' },
  { key: 'mobile', icon: Smartphone, label: 'Mobile' },
];

export default function EditorToolbar({
  device, setDevice, onUndo, onRedo, canUndo, canRedo,
  onSaveDraft, onPreview, onPublish, onClose, onReset, saveState, saving, publishing,
}) {
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2.5 bg-slate-900 border-b border-slate-800 flex-wrap">
      <div className="flex items-center gap-3">
        <Button size="sm" variant="outline" onClick={onClose} data-testid="editor-close" className="border-slate-700 text-white hover:bg-slate-800">
          <X className="w-4 h-4 mr-1.5" /> Close
        </Button>
        <div>
          <div className="text-white font-semibold text-sm leading-tight">Home Page Editor</div>
          <div className="text-[11px] text-gray-500" data-testid="save-state">{saveState}</div>
        </div>
      </div>

      <div className="flex items-center gap-1 bg-slate-950 rounded-md p-1 border border-slate-800">
        {DEVICES.map(({ key, icon: Icon, label }) => (
          <button key={key} type="button" data-testid={`device-${key}`} onClick={() => setDevice(key)}
            title={label}
            className={`p-1.5 rounded transition-all ${device === key ? 'bg-red-600 text-white' : 'text-gray-400 hover:text-white'}`}>
            <Icon className="w-4 h-4" />
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <Button size="icon" variant="outline" onClick={onUndo} disabled={!canUndo} data-testid="editor-undo" title="Undo" className="border-slate-700 text-white hover:bg-slate-800 w-8 h-8"><Undo2 className="w-4 h-4" /></Button>
        <Button size="icon" variant="outline" onClick={onRedo} disabled={!canRedo} data-testid="editor-redo" title="Redo" className="border-slate-700 text-white hover:bg-slate-800 w-8 h-8"><Redo2 className="w-4 h-4" /></Button>
        <Button size="sm" variant="outline" onClick={onReset} data-testid="editor-reset" title="Rebuild from original content" className="border-slate-700 text-gray-300 hover:bg-slate-800"><RotateCcw className="w-4 h-4 mr-1.5" /> Reset</Button>
        <Button size="sm" variant="outline" onClick={onSaveDraft} disabled={saving} data-testid="editor-save-draft" className="border-slate-700 text-white hover:bg-slate-800"><Save className="w-4 h-4 mr-1.5" /> {saving ? 'Saving…' : 'Save Draft'}</Button>
        <Button size="sm" variant="outline" onClick={onPreview} data-testid="editor-preview" className="border-slate-700 text-white hover:bg-slate-800"><Eye className="w-4 h-4 mr-1.5" /> Preview</Button>
        <Button size="sm" onClick={onPublish} disabled={publishing} data-testid="editor-publish" className="bg-red-600 hover:bg-red-700 text-white"><Rocket className="w-4 h-4 mr-1.5" /> {publishing ? 'Publishing…' : 'Publish'}</Button>
      </div>
    </div>
  );
}
